import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

export default function ({ className = "py-5 py-md-6", theme = "light", video }) {
  return (
    <div className={cn(className)} data-bs-theme={theme}>
      <Container fluid="md">
        <Row>
          <Col xs={12} md={12}>
            <iframe
              width="100%"
              height="600"
              style={{ border: "unset" }}
              src="https://www.evertreen.com/forest/66608ed3c286b?iframe=1"
            >
            </iframe>
            <div className="videoWrapper">
              <h1 className="text-center mt-5">See the Impact HRS Have Made</h1>
              <div className="videoFrame">
                <iframe width="1080" height="608" src="https://www.youtube.com/embed/m2EDA64-Vn4?si=ah2CF0pmxk2AbFx5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
